import { BaseEntity } from "yt-ng-framework";

export class InstrukcijaZaPlacanjeByFirmaId extends BaseEntity{
    constructor(){
        super();
    }
    FirmaZrcID: number = null;
    FirmaZrc: string = null;
    Instrukcija: string = null;

    Deserialize(input: any){
        this.FirmaZrcID = input.FirmaZrcID;
        this.FirmaZrc = input.FirmaZrc;
        this.Instrukcija = input.Instrukcija;
        return this;
    }

    Serialize(input: InstrukcijaZaPlacanjeByFirmaId){
        return input;
    }

}